// extracted by mini-css-extract-plugin
export default {"opponentsColumn":"opponentsColumn-Sg1NwJLQ","dateColumn":"dateColumn-m72oxST3"};